export default __webpack_public_path__ + "static/media/fv_customers.d8852952.svg";